<template>
  <div>
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12 sm6>
          <v-btn
            depressed
            :outline="filter != 'all'"
            :color="filter == 'all' ? 'primary' : 'grey'"
            class="ma-0 mr-1 mb-1"
            @click="
              filter = 'all'
              getAnswerReport()
            "
            >{{ $t('All') }}</v-btn
          >
          <v-btn
            depressed
            :outline="filter != 'facebook'"
            :color="filter == 'facebook' ? 'primary' : 'grey'"
            class="ma-0 mr-1 mb-1"
            @click="
              filter = 'facebook'
              getAnswerReport()
            "
          >
            <em class="fab fa-facebook-square mr-1" />
            {{ $t('Facebook') }}
          </v-btn>
          <v-btn
            depressed
            :outline="filter != 'line'"
            :color="filter == 'line' ? 'primary' : 'grey'"
            class="ma-0 mr-1 mb-1"
            @click="
              filter = 'line'
              getAnswerReport()
            "
          >
            <em class="fab fa-line mr-1" />
            {{ $t('Line') }}
          </v-btn>
          <v-btn
            depressed
            :outline="filter != 'webchat'"
            :color="filter == 'webchat' ? 'primary' : 'grey'"
            class="ma-0 mr-1 mb-1"
            @click="
              filter = 'webchat'
              getAnswerReport()
            "
          >
            <em class="fas fa-globe mr-1" />
            Web Chat
          </v-btn>
          <v-btn
            depressed
            :outline="filter != 'app'"
            :color="filter == 'app' ? 'primary' : 'grey'"
            class="ma-0 mr-1 mb-1"
            @click="
              filter = 'app'
              getAnswerReport()
            "
          >
            <em class="fas fa-mobile-alt mr-1" />
            App Chat
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-sm-right">
          <v-btn
            outline
            color="grey"
            class="ma-0 mb-1"
            :loading="loadingExport"
            @click="getXlsxData"
          >
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>

      <date-filter
        v-model="selectedDate"
        :default-filter="'today'"
        @onSelected="getAnswerReport"
      ></date-filter>
      <v-layout wrap>
        <v-flex xs6 class="pt-4">
          <AnswerBotGraph v-if="botData" :loading="loading" :data="botData" />
        </v-flex>
        <v-flex xs6 class="pl-5 pt-4">
          <v-card flat style="border: 1px solid #ff706b; border-radius: 8px" max-width="350px">
            <v-layout wrap>
              <v-flex
                xs12
                class="text-xs-center primary--text py-2"
                style="border-bottom: 1px solid #ff706b; font-weight: 700"
                >จำนวนที่บอทตอบได้</v-flex
              >
              <v-flex
                xs6
                class="text-xs-center primary--text"
                style="font-size: 24px; border-right: 1px solid #ff706b"
                >{{ botData.bot_answer ? botData.bot_answer : '-' }}</v-flex
              >
              <v-flex xs6 class="text-xs-center primary--text" style="font-size: 24px">{{
                botData.bot_answer_percent ? `${botData.bot_answer_percent} %` : '-'
              }}</v-flex>
            </v-layout>
          </v-card>
          <v-card
            flat
            style="border: 1px solid #9e9e9e; border-radius: 8px"
            class="mt-4"
            max-width="350px"
          >
            <v-layout wrap>
              <v-flex
                xs12
                class="text-xs-center gray--text py-2"
                style="border-bottom: 1px solid #9e9e9e; font-weight: 700"
                >จำนวนที่บอทตอบไม่ได้</v-flex
              >
              <v-flex
                xs6
                class="text-xs-center gray--text"
                style="font-size: 24px; border-right: 1px solid #9e9e9e"
                >{{ botData.bot_answer ? botData.bot_not_answer : '-' }}</v-flex
              >
              <v-flex xs6 class="text-xs-center gray--text" style="font-size: 24px">{{
                botData.bot_answer_percent ? `${botData.bot_not_answer_percent} %` : '-'
              }}</v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12 class="pt-3">
          <!-- :selectedDate="sortedDate" -->
          <TagReportGraph v-if="tagReportData.length" :loading="loading" :data="tagReportData" />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import moment from 'moment'
import AnswerBotGraph from './../AnswerBotGraph.vue'
import DateFilter from './../DateFilter'
import TagReportGraph from './../tag/TagReportGraph'
import * as XLSX from 'xlsx'

export default {
  components: {
    AnswerBotGraph,
    DateFilter,
    TagReportGraph
  },
  data() {
    return {
      filter: 'all',
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      tagReportData: [],
      botData: {
        bot_answer: null,
        bot_answer_percent: null,
        bot_not_answer: null,
        bot_not_answer_percent: null
      },
      loading: false,
      loadingExport: false
    }
  },
  mounted() {
    this.getAnswerReport()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    async getXlsxData() {
      const vm = this
      vm.loadingExport = true
      let json = []
      const startDate = moment(vm.selectedDate.start).format('DD/MM/YYYY')
      const endDate = moment(vm.selectedDate.end).format('DD/MM/YYYY')

      json.push([`${this.$t('from')}: ${startDate}  ${this.$t('to')}: ${endDate}`])
      json.push(['Tag report by Date'])
      json.push([`Channel ${vm.filter}`])
      json.push(['Bot answered', '', 'Bot not answer'])
      json.push(['Count', vm.botData.bot_answer, 'Count', vm.botData.bot_not_answer])
      json.push([
        'Percentage',
        `${vm.botData.bot_answer_percent}%`,
        'Percentage',
        `${vm.botData.bot_not_answer_percent}%`
      ])
      json.push([''])
      json.push(['Topic', 'Count'])
      $.each(vm.tagReportData, function (index, seriesData) {
        json.push([seriesData.usertags, seriesData.count])
      })

      vm.loadingExport = false
      const heading = [['', '']]
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, json, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `gpf-answer-report.xlsx`)
    },
    async getAnswerReport() {
      const vm = this
      try {
        const data = {
          pageId: vm.selectedBot.pageid,
          channel: vm.filter,
          startDate: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
          endDate: moment(vm.selectedDate.end).format('YYYY-MM-DD')
        }

        vm.$store.dispatch('loading')
        const response = await api.gpfGetAnswerReport(data)
        if (response) {
          vm.tagReportData = response.data
          vm.botData = {
            bot_answer: response.bot_answer,
            bot_answer_percent: response.bot_answer_percent,
            bot_not_answer: response.bot_not_answer,
            bot_not_answer_percent: response.bot_not_answer_percent
          }
          vm.$store.dispatch('clear_loading')
        }
      } catch (error) {
        console.error(error)
        return
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/GpfAnswerReport.vue